import axiosInstance from "core/api/axiosInstance";

export const getTableroSac = async (tipo, { signal } = {}) => {
  try {
    // Validar parámetro tipo
    if (!tipo || typeof tipo !== "string") {
      throw new Error("El tipo de tablero es requerido y debe ser una cadena");
    }

    const { data } = await axiosInstance.get(`/api/dashboard/get-data/${tipo}`, { signal });
    return data;
  } catch (error) {
    if (signal?.aborted) throw error;
    console.error("Error en getTableroSac:", error);

    // Manejo específico de errores
    if (error.response?.status === 404) {
      throw new Error(`No se encontró el tablero de tipo: ${tipo}`);
    }
    if (error.response?.status === 400) {
      throw new Error("Tipo de tablero inválido");
    }

    throw new Error(error.response?.data?.message || "Error al obtener datos del tablero SAC");
  }
};
